import { Link } from '@tanstack/react-router';
import { OPERATOR_REGISTRATION_LABELS } from '@signalvote/shared';
import { useMessagingProfiles } from '@/hooks/queries';
import { ReadNotice } from '@/components/ui';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

/**
 * Platform-admin list of every campaign's 10DLC registration. The API orders it (campaigns
 * with a send waiting on registration first, by scheduled send), so rows render as given.
 */
export function MessagingProfilesList() {
  const read = useMessagingProfiles();

  if (read.status === 'failed' || read.status === 'offline') {
    return (
      <div className="p-6">
        <ReadNotice read={read} subject="messaging profiles" />
      </div>
    );
  }
  if (read.status !== 'ready') {
    return <div className="p-6 text-muted-foreground">Loading messaging profiles…</div>;
  }
  const data = read.data;

  return (
    <div className="mx-auto max-w-5xl space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-semibold">Messaging profiles</h1>
        <p className="text-sm text-muted-foreground">
          Campaigns waiting on registration come first, in the order their texts go out.
        </p>
      </div>
      {data.items.length === 0 ? (
        <p className="text-sm text-muted-foreground">No campaigns yet.</p>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Campaign</TableHead>
              <TableHead>Registration</TableHead>
              <TableHead>Committee</TableHead>
              <TableHead>Scheduled send</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.items.map((item) => (
              <TableRow key={item.campaignId}>
                <TableCell className="font-medium">{item.campaignName}</TableCell>
                <TableCell>{OPERATOR_REGISTRATION_LABELS[item.status]}</TableCell>
                <TableCell>{item.facts.legalName ?? '—'}</TableCell>
                <TableCell>
                  {item.waitingSend?.sendDate
                    ? [item.waitingSend.sendDate, item.waitingSend.sendTime].filter(Boolean).join(' ')
                    : '—'}
                </TableCell>
                <TableCell>
                  <Link to="/admin/messaging/profile" search={{ campaignId: item.campaignId }}>
                    Open profile
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
